import { toast } from 'react-toastify';

export const copyToClipboard = (text, successMessage) => {
  navigator.clipboard.writeText(text);
  toast.success(successMessage);
};
